// src/data/blogData.js
export const blogPosts = [
  {
    id: 1,
    title:
      "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
    slug: "design24-ra-mat-bo-cong-cu-ai",
    author: "Design24 Team",
    date: "16 Tháng 9, 2025",
    category: "Công Nghệ",

    homeImg: "/assets/img/news/ai-chat-studio/dt1.png",
    image: "/assets/img/news/ai-chat-studio/dt1.png",
    content: [
      {
        type: "highlight",
        value:
          "Học viện Design24 chính thức công bố bộ công cụ AI 'Made in Vietnam'",
      },
      {
        type: "text",
        value:
          "Học viện Design24 vừa chính thức công bố ra mắt hai nền tảng công nghệ: Design24 AI Chat và Design24 AI Studio. Đây là bộ công cụ trí tuệ nhân tạo (AI) được phát triển hoàn toàn bởi đội ngũ kỹ sư, lập trình viên người Việt, với mục tiêu đặc biệt dành riêng cho sinh viên và giới trẻ Việt Nam, nhằm thúc đẩy việc ứng dụng AI vào học tập và sáng tạo.",
      },

      {
        type: "highlight",
        value: "Giải pháp 'Made in Vietnam' cho người Việt",
      },
      {
        type: "text",
        value:
          "Trong bối cảnh công nghệ AI đang phát triển mạnh mẽ trên toàn cầu, việc các nền tảng lớn thường tập trung vào ngôn ngữ và văn hóa phương Tây đã gây ra không ít khó khăn cho người dùng Việt. Nắm bắt được thực tế này, Design24 đã nghiên cứu và phát triển một giải pháp 'nội địa hóa' hiệu quả.",
      },
      {
        type: "text",
        value:
          "Design24 AI Chat được giới thiệu là trợ lý AI đa phương tiện, có khả năng xử lý ngôn ngữ tự nhiên tiếng Việt một cách thông minh, giúp người dùng dễ dàng truy vấn thông tin, lên ý tưởng và hỗ trợ học tập một cách hiệu quả. Đây không chỉ là một công cụ tiện ích mà còn là một bước tiến quan trọng trong việc thu hẹp khoảng cách tiếp cận công nghệ cho cộng đồng người Việt.",
      },
      {
        type: "text",
        value:
          "Đặc biệt, Design24 AI Studio được kỳ vọng sẽ trở thành một 'bộ công cụ sáng tạo mạnh nhất hiện nay' với các tính năng đa dạng, từ sáng tạo nội dung văn bản, hình ảnh, thiết kế đồ họa cho đến sản xuất TVC quảng cáo, tạo giọng nói (voice) và âm nhạc. Sự tích hợp nhiều tính năng trong một nền tảng duy nhất giúp sinh viên và các nhà sáng tạo tiết kiệm thời gian, tối ưu hóa quy trình làm việc và biến những ý tưởng phức tạp thành sản phẩm hoàn chỉnh một cách dễ dàng.",
      },

      {
        type: "highlight",
        value: "Mở rộng cơ hội học tập và thực hành miễn phí",
      },
      {
        type: "text",
        value:
          "Một trong những điểm nhấn của dự án này là việc Học viện Design24 cam kết cung cấp các công cụ này hoàn toàn miễn phí cho học viên của mình, cũng như sinh viên tại các trường đại học và cao đẳng. Đây là động thái tích cực nhằm khuyến khích thế hệ trẻ Việt Nam không chỉ là người tiêu dùng công nghệ mà còn là người làm chủ và sáng tạo nên những giá trị mới từ công nghệ.",
      },

      {
        type: "highlight",
        value: "Chia sẻ từ CEO & Founder Design24",
      },
      {
        type: "text",
        value:
          "Ông Nguyễn Hoài Anh – CEO & Founder Học viện Design24 chia sẻ: 'Việc đầu tư vào phát triển các công cụ AI không chỉ nhằm hỗ trợ học viên trong học tập và thực hành, mà còn giúp họ hình thành tư duy chiến lược, tạo lợi thế cạnh tranh khi bước vào thị trường lao động trong kỷ nguyên số.'",
      },

      {
        type: "highlight",
        value: "Bước tiến quan trọng cho cộng đồng công nghệ Việt",
      },
      {
        type: "text",
        value:
          "Sự ra đời của Design24 AI Chat và Design24 AI Studio không chỉ là một dấu mốc quan trọng đối với Học viện Design24 mà còn là tín hiệu đáng mừng cho cộng đồng công nghệ Việt Nam, cho thấy khả năng tự chủ và sáng tạo của đội ngũ kỹ sư trong nước.",
      },
    ],
    images: [
      "/assets/img/news/ai-chat-studio/dt2.png",
      "/assets/img/news/ai-chat-studio/dt3.png",
    ],
    contentExtra:
      "Bộ công cụ AI 'Made in Vietnam' từ Design24 giúp sinh viên và giới trẻ sáng tạo, học tập hiệu quả, hoàn toàn miễn phí.",
    tags: ["AI", "Công Nghệ", "Design24", "Made in Vietnam", "Sáng Tạo"],
    comments: [
      {
        name: "Nguyễn Văn Khải",
        date: "16 Tháng 9, 2025 lúc 10:15",
        message:
          "Thật tuyệt vời khi có bộ công cụ AI dành riêng cho người Việt, rất tiện cho học tập!",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Trần Thị Minh Châu",
        date: "16 Tháng 9, 2025 lúc 11:30",
        message:
          "Mình thử AI Studio và thấy giao diện trực quan, các tính năng khá đầy đủ, đáng để trải nghiệm.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Phạm Hoàng Long",
        date: "16 Tháng 9, 2025 lúc 12:45",
        message:
          "Design24 AI Chat thật sự thông minh, hỗ trợ mình làm việc và học tập hiệu quả hơn rất nhiều!",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Lê Thị Hồng Nhung",
        date: "16 Tháng 9, 2025 lúc 13:10",
        message:
          "Rất vui khi có bộ công cụ AI Made in Vietnam, dễ sử dụng và phù hợp với sinh viên.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Đặng Văn Tuấn",
        date: "16 Tháng 9, 2025 lúc 14:25",
        message:
          "Các tính năng trong AI Studio quá đa dạng, mình đã thử tạo ảnh rất nhanh chóng và chân thực.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],

    sidebar: {
      categories: [
        { name: "Công Nghệ", count: 5, active: true },
        { name: "AI & Machine Learning", count: 3 },
        { name: "Học Tập", count: 4 },
        { name: "Sáng Tạo Nội Dung", count: 2 },
        { name: "Thiết Kế", count: 6 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["AI", "Design24", "Sáng Tạo", "Công Nghệ", "Made in Vietnam"],
    },
  },

  {
    id: 2,
    title:
      "Chia Sẻ Kiến Thức | 5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
    slug: "5-cong-cu-thiet-ke-online-mien-phi",
    author: "Design24 Team",
    date: "07 Tháng 9, 2025",
    category: "Thiết Kế",

    homeImg: "/assets/img/news/5-tools-design-online/dt2.png",
    image: "/assets/img/news/5-tools-design-online/dt1.png",
    content: [
      {
        type: "highlight",
        value:
          "Bạn muốn thiết kế poster, banner, infographic hay một video ngắn ấn tượng nhưng lại không rành Photoshop hay Illustrator? Đừng lo!",
      },
      {
        type: "text",
        value:
          "Thế giới công cụ thiết kế online miễn phí ngày nay vô cùng đa dạng, giúp bạn tạo ra sản phẩm chuyên nghiệp chỉ với vài thao tác đơn giản. Dù bạn là sinh viên, dân văn phòng, marketer hay chỉ đơn giản là người yêu thích sáng tạo – việc nắm trong tay những công cụ hỗ trợ cơ bản sẽ giúp tiết kiệm thời gian, chi phí mà vẫn có được thành phẩm đẹp mắt.",
      },
      {
        type: "highlight",
        value:
          "Trong bài viết này, Design24 sẽ giới thiệu đến bạn 5 công cụ thiết kế online miễn phí tốt nhất – dễ dùng, tiện lợi và phù hợp cho mọi đối tượng, đặc biệt là người mới bắt đầu.",
      },

      // Canva
      {
        type: "highlight",
        value: "1. Canva – “Ngôi sao quốc dân” trong làng thiết kế online",
      },
      {
        type: "text",
        value:
          "Canva được mệnh danh là công cụ thiết kế phổ biến nhất hiện nay. Với giao diện kéo – thả trực quan, bạn dễ dàng tạo ra poster, banner, infographic, CV, bài thuyết trình hay thậm chí video chỉ trong vài phút.",
      },
      {
        type: "text",
        value:
          "Kho template khổng lồ với hàng ngàn mẫu miễn phí được thiết kế sẵn sẽ giúp bạn tiết kiệm rất nhiều thời gian. Canva phù hợp cho cả học tập, công việc lẫn sáng tạo nội dung trên mạng xã hội.",
      },
      { type: "text", value: "👉 Trải nghiệm ngay tại: canva.com" },

      // Adobe Spark
      {
        type: "highlight",
        value: "2. Adobe Spark – Thiết kế nhanh gọn trong tích tắc",
      },
      {
        type: "text",
        value:
          "Nếu bạn thường xuyên làm việc với video và nội dung trực tuyến, Adobe Spark là lựa chọn đáng thử. Chỉ cần chèn hình ảnh, thêm chữ, sắp xếp bố cục hợp lý, bạn đã có ngay sản phẩm sáng tạo đẹp mắt.",
      },
      {
        type: "text",
        value:
          "Điểm cộng lớn là Spark có cả phiên bản di động, giúp bạn chỉnh sửa thiết kế mọi lúc mọi nơi. Với kho template chuyên nghiệp từ chính Adobe, bạn sẽ không bao giờ lo thiếu ý tưởng.",
      },
      { type: "text", value: "👉 Khám phá tại: spark.adobe.com" },

      // Pablo
      {
        type: "highlight",
        value: "3. Pablo – Ứng dụng tạo ảnh “deep” cực chất",
      },
      {
        type: "text",
        value:
          "Pablo đặc biệt phù hợp với những ai thích làm ảnh trích dẫn (quote) trên mạng xã hội. Chỉ với vài bước đơn giản, bạn có thể thêm chữ vào ảnh, chỉnh sửa font, màu sắc để tạo nên hình ảnh ấn tượng.",
      },
      {
        type: "text",
        value:
          "Với giao diện siêu đơn giản, Pablo là công cụ cực kỳ dễ dùng cho người mới bắt đầu. Nó sẽ giúp bạn biến những câu nói truyền cảm hứng thành hình ảnh “cực deep” chỉ trong vài phút.",
      },
      { type: "text", value: "👉 Trải nghiệm tại: pablo.buffer.com" },

      // Piktochart
      {
        type: "highlight",
        value: "4. Piktochart – Chuyên gia thiết kế Infographic miễn phí",
      },
      {
        type: "text",
        value:
          "Khi cần biến số liệu khô khan thành biểu đồ trực quan và infographic bắt mắt, Piktochart chính là “cánh tay phải” đắc lực. Đây là công cụ rất hữu ích trong học tập, báo cáo và thuyết trình.",
      },
      {
        type: "text",
        value:
          "Thư viện template infographic đa dạng cho phép bạn nhanh chóng thiết kế báo cáo, thuyết trình, tờ rơi hay nội dung mạng xã hội mà không cần kỹ năng phức tạp. Piktochart giúp thông tin của bạn trở nên dễ hiểu và hấp dẫn hơn.",
      },
      { type: "text", value: "👉 Trải nghiệm tại: piktochart.com" },

      // Vectr
      {
        type: "highlight",
        value: "5. Vectr – Lựa chọn lý tưởng cho thiết kế vector cơ bản",
      },
      {
        type: "text",
        value:
          "Nếu Illustrator quá phức tạp và tốn phí, Vectr là lựa chọn thay thế hoàn hảo cho người mới. Công cụ này cho phép bạn thiết kế logo, icon, favicon hoặc các sản phẩm vector đơn giản một cách nhanh chóng.",
      },
      {
        type: "text",
        value:
          "Dù không mạnh mẽ bằng Illustrator, nhưng Vectr miễn phí và dễ dùng chính là điểm cộng lớn. Bạn có thể sử dụng trực tuyến hoặc tải về máy để thiết kế ngay cả khi không có internet.",
      },
      { type: "text", value: "👉 Bắt đầu tại: vectr.com" },

      {
        type: "highlight",
        value:
          "Chỉ với 5 công cụ thiết kế online miễn phí trên, bạn đã có thể tự tin sáng tạo mọi nội dung – từ học tập, công việc đến xây dựng thương hiệu cá nhân.",
      },
      {
        type: "text",
        value:
          "Đây là những lựa chọn cực kỳ phù hợp cho người mới, giúp bạn tiết kiệm chi phí, tiết kiệm thời gian mà vẫn tạo ra sản phẩm đẹp mắt, chuyên nghiệp.",
      },
      {
        type: "text",
        value:
          "👉 Hãy thử ngay và chọn cho mình công cụ phù hợp nhất để bắt đầu hành trình sáng tạo!",
      },
    ],

    images: [
      "/assets/img/news/5-tools-design-online/dt1.png",
      "/assets/img/news/5-tools-design-online/dt2.png",
    ],
    contentExtra:
      "5 công cụ thiết kế online miễn phí: dễ dùng, tiện lợi và phù hợp cho mọi đối tượng – lựa chọn hoàn hảo cho người mới bắt đầu sáng tạo.",
    tags: ["Thiết Kế", "Công Cụ Online", "Canva", "Infographic", "Design24"],
    comments: [
      {
        name: "Nguyễn Văn Hải",
        date: "07 Tháng 9, 2025 lúc 10:45",
        message:
          "Bài viết rất hữu ích, mình mới thử Canva và thấy cực kỳ dễ dùng.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Trần Thị Thu",
        date: "07 Tháng 9, 2025 lúc 13:20",
        message:
          "Mình thích Piktochart vì hỗ trợ làm infographic nhanh cho bài thuyết trình.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Phạm Minh Quân",
        date: "07 Tháng 9, 2025 lúc 15:05",
        message:
          "Adobe Spark tiện thật, chỉnh sửa trên điện thoại cũng rất mượt, phù hợp cho người bận rộn.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Lê Hoàng Anh",
        date: "07 Tháng 9, 2025 lúc 16:40",
        message:
          "Pablo khá đơn giản, mình tạo quote cho fanpage trong vài phút, rất tiện.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Võ Thị Mai",
        date: "07 Tháng 9, 2025 lúc 17:20",
        message:
          "Vectr tuy không mạnh bằng Illustrator nhưng đủ để mình tạo logo cơ bản, rất hài lòng.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9, active: true },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["Thiết Kế", "Online", "Canva", "Infographic", "Sáng Tạo"],
    },
  },
  {
    id: 3,
    title: "Khóa Học 10 Kỹ Năng A.I Tại Học Viện Design24",
    slug: "khoa-hoc-10-ky-nang-ai-design24",
    author: "Admin",
    date: "27 Tháng 8, 2025",
    category: "A.I",

    homeImg: "/assets/img/news/khoa-hoc-10-ky-nang-ai-design24/dt3.jpg",
    image: "/assets/img/news/khoa-hoc-10-ky-nang-ai-design24/dt1.jpg",
    content: [
      {
        type: "highlight",
        value:
          "Khóa học A.I tại Học viện Design24 – 10 kỹ năng AI thực chiến, ứng dụng sáng tạo, hỗ trợ 50% học phí, tặng Canva Pro & ChatGPT Plus.",
      },
      {
        type: "text",
        value:
          "Trong kỷ nguyên số, A.I (Trí tuệ nhân tạo) hiện hữu trong từng “cú click” hằng ngày: từ ChatGPT gợi ý ý tưởng, Canva A.I thiết kế poster, đến TikTok gợi ý nội dung hợp gu – tất cả đều minh chứng A.I đang định hình cuộc sống, học tập và công việc.",
      },
      {
        type: "highlight",
        value:
          "Người trẻ đang đứng trước “cơn sóng thần” A.I – rút ngắn hàng giờ làm việc chỉ còn vài phút, mở ra siêu năng lực làm nhiều hơn, nhanh hơn, sáng tạo hơn.",
      },
      {
        type: "text",
        value:
          "Sinh viên có thể dùng A.I để tóm tắt tài liệu học tập, luyện tiếng Anh, mô phỏng bài thuyết trình. Người đi làm tự động hóa báo cáo, tạo slide, viết email. Freelancer và startup thiết kế, dựng video, sáng tạo nội dung marketing mà không cần đầu tư máy móc đắt đỏ.",
      },
      {
        type: "highlight",
        value: "Ứng dụng A.I trong sáng tạo và kinh doanh:",
      },
      {
        type: "text",
        value:
          "Content Marketing & SEO: tạo tiêu đề hấp dẫn, phân tích từ khóa, lên dàn ý bài chuẩn SEO trong vài giây.",
      },
      {
        type: "text",
        value:
          "Thiết kế & Truyền thông đa phương tiện: Canva A.I, Adobe Firefly, Runway Gen-2 giúp bất kỳ ai trở thành nhà thiết kế hoặc dựng phim bán chuyên.",
      },
      {
        type: "text",
        value:
          "Kinh doanh & Khởi nghiệp: chatbot, voice bot thông minh chăm sóc khách hàng 24/7, tiết kiệm chi phí nhân sự.",
      },
      {
        type: "text",
        value:
          "Giáo dục & Học tập: A.I trở thành gia sư online – hỗ trợ giải bài tập, luyện ngôn ngữ, tạo flashcard ôn thi.",
      },
      {
        type: "highlight",
        value:
          "Theo McKinsey 2025, A.I có thể đóng góp 4,4 nghìn tỷ USD vào GDP toàn cầu mỗi năm – khẳng định đây là năng lực nền tảng để cạnh tranh trong tương lai.",
      },
      {
        type: "text",
        value:
          "Khóa học 10 kỹ năng A.I tại Design24 là chương trình thực chiến: học xong áp dụng ngay.",
      },
      {
        type: "highlight",
        value: "10 kỹ năng nền tảng của khóa học:",
      },
      {
        type: "list",
        value: [
          "Sáng tạo nội dung bằng A.I",
          "Sáng tạo hình ảnh A.I",
          "Chụp ảnh & chỉnh sửa thông minh",
          "Kỹ xảo hình ảnh với A.I",
          "Thiết kế trình chiếu sáng tạo",
          "Kỹ xảo phim ảnh",
          "Sáng tạo âm nhạc bằng A.I",
          "Dựng voice A.I",
          "Dựng phim chuyên nghiệp",
          "Quay video ấn tượng",
        ],
      },

      {
        type: "highlight",
        value: "Tại sao bạn nên học ngay hôm nay?",
      },
      {
        type: "text",
        value:
          "A.I chỉ mạnh khi biết cách khai thác. Nhiều bạn trẻ chỉ thử nghiệm cho vui, nếu không trang bị kỹ năng sẽ bỏ lỡ cơ hội. Khóa học giúp bạn tận dụng A.I để bứt phá sự nghiệp.",
      },
      {
        type: "highlight",
        value: "* Ưu đãi đặc biệt:",
      },
      {
        type: "text",
        value: (
          <ul className="professional-list">
            <li>
              <span className="list-item-icon">✓</span> Học phí hỗ trợ 50% từ Sở
              Khoa học & Công nghệ TP. Cần Thơ.
            </li>
            <li>
              <span className="list-item-icon">✓</span> Quà tặng: 01 năm Canva
              Pro + 03 tháng ChatGPT Plus.
            </li>
            <li>
              <span className="list-item-icon">✓</span> Giới hạn cho 24 học viên
              đăng ký sớm nhất.
            </li>
          </ul>
        ),
      },
      {
        type: "highlight",
        value:
          "Đây chính là tấm vé thông hành để sở hữu lợi thế cạnh tranh trong học tập, sự nghiệp và khởi nghiệp, làm chủ kỷ nguyên A.I.",
      },
    ],
    images: [
      "/assets/img/news/khoa-hoc-10-ky-nang-ai-design24/dt2.jpg",
      "/assets/img/news/khoa-hoc-10-ky-nang-ai-design24/dt3.jpg",
    ],
    contentExtra:
      "Khóa học trang bị kỹ năng A.I thực chiến, hỗ trợ học phí 50% và công cụ sáng tạo không giới hạn – cơ hội để bứt phá trong thời đại số.",
    tags: ["A.I", "Học Viện Design24", "Công Nghệ", "Sáng Tạo", "Marketing"],
    comments: [
      {
        name: "Nguyễn Minh Hoàng",
        date: "27 Tháng 8, 2025 lúc 14:10",
        message:
          "Khóa học rất thiết thực, nội dung thực chiến giúp học viên áp dụng ngay trong công việc và dự án cá nhân.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Lê Thùy Trang",
        date: "27 Tháng 8, 2025 lúc 15:25",
        message:
          "Ưu đãi học phí và quà tặng công cụ A.I rất hấp dẫn, giúp mình có động lực đăng ký ngay.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Trần Văn Nam",
        date: "27 Tháng 8, 2025 lúc 16:30",
        message:
          "Mình thấy khóa học rất thực tế, các kỹ năng A.I giúp ích nhiều cho công việc hiện tại.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Phạm Thị Lan Anh",
        date: "27 Tháng 8, 2025 lúc 19:15",
        message:
          "Giáo trình rõ ràng, dễ hiểu, đặc biệt các ví dụ minh họa giúp mình áp dụng nhanh.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Nguyễn Thùy Linh",
        date: "27 Tháng 8, 2025 lúc 20:00",
        message:
          "Thực sự thích phần bài tập thực hành, giúp mình nâng cao kỹ năng A.I nhanh chóng.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
    ],

    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3, active: true },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: [
        "Branding",
        "Nhận Diện",
        "Chiến Lược",
        "Marketing",
        "Kỷ Nguyên Số",
      ],
    },
  },
  // {
  //   id: 3,
  //   title: "Tối Ưu Tác Động Thương Hiệu Qua Giải Pháp Số Sáng Tạo",
  //   slug: "toi-uu-tac-dong-thuong-hieu",
  //   author: "Admin",
  //   date: "20 Tháng 12, 2024",
  //   category: "Marketing",
  //   homeImg: "/assets/img/news/toi-uu-tac-dong-thuong-hieu/dt2.webp",
  //   image: "/assets/img/news/toi-uu-tac-dong-thuong-hieu/dt1.webp",
  //   content: [
  //     {
  //       type: "text",
  //       value:
  //         "Tại Design24, chúng tôi tận dụng các giải pháp kỹ thuật số sáng tạo để gia tăng tác động thương hiệu, từ chiến lược nội dung cho đến việc tạo ra hình ảnh trực quan thu hút và ấn tượng.",
  //     },
  //     {
  //       type: "highlight",
  //       value:
  //         "Điểm mạnh của Design24 là khai thác các công cụ kỹ thuật số sáng tạo để tối ưu tác động thương hiệu. Chúng tôi tập trung vào nội dung chiến lược, hình ảnh trực quan và trải nghiệm số liền mạch để tạo sự khác biệt trên thị trường.",
  //     },
  //     {
  //       type: "text",
  //       value:
  //         "Các chiến dịch marketing kỹ thuật số của Design24 được xây dựng để kết nối với khách hàng mục tiêu một cách trực quan và hiệu quả. Chúng tôi luôn chú trọng đến việc tối ưu hóa các chiến lược để đảm bảo tính tương tác cao từ người dùng.",
  //     },
  //     {
  //       type: "text",
  //       value:
  //         "Đội ngũ của Design24 kết hợp sáng tạo vô hạn với phân tích dữ liệu để đảm bảo rằng mỗi dự án không chỉ mang lại giá trị lớn cho thương hiệu mà còn có tính ứng dụng cao trong môi trường kinh doanh cạnh tranh hiện nay.",
  //     },
  //   ],
  //   images: [
  //     "/assets/img/news/toi-uu-tac-dong-thuong-hieu/dt2.webp",
  //     "/assets/img/news/toi-uu-tac-dong-thuong-hieu/dt3.webp",
  //   ],
  //   contentExtra:
  //     "Chúng tôi cam kết cung cấp giải pháp số toàn diện, từ việc xây dựng ý tưởng, thiết kế đến triển khai, giúp thương hiệu nổi bật và ghi dấu ấn mạnh mẽ trong môi trường cạnh tranh ngày càng khốc liệt.",
  //   tags: ["Marketing", "Thương Hiệu"],
  //   comments: [
  //     {
  //       name: "Nguyễn Gia Hưng",
  //       date: "20 Tháng 3, 2024 lúc 14:37",
  //       message:
  //         "Chiến dịch này được triển khai rất chuyên nghiệp, vừa sáng tạo vừa hiệu quả, đáp ứng hoàn hảo mục tiêu đề ra.",
  //       rating: 5,
  //       avatar: "/assets/img/news/c2.webp",
  //     },
  //     {
  //       name: "Hồ Thị Diệu Mai",
  //       date: "21 Tháng 3, 2024 lúc 09:12",
  //       message:
  //         "Rất ấn tượng với cách Design24 kết hợp kỹ thuật số và sáng tạo để nâng cao tác động thương hiệu. Đây thực sự là một chiến lược thông minh.",
  //       rating: 5,
  //       avatar: "/assets/img/news/c1.webp",
  //     },
  //     {
  //       name: "Trần Quốc Huy",
  //       date: "22 Tháng 3, 2024 lúc 16:48",
  //       message:
  //         "Nội dung được triển khai mạch lạc, phần hình ảnh trực quan cũng rất bắt mắt. Rõ ràng đội ngũ đã đầu tư công sức nghiêm túc.",
  //       rating: 4,
  //       avatar: "/assets/img/news/c2.webp",
  //     },
  //     {
  //       name: "Phạm Minh Khôi",
  //       date: "23 Tháng 3, 2024 lúc 11:25",
  //       message:
  //         "Chiến dịch số ấn tượng, tuy nhiên nếu có thêm ví dụ minh họa từ các case study thực tế thì sẽ dễ hình dung hơn.",
  //       rating: 4,
  //       avatar: "/assets/img/news/c2.webp",
  //     },
  //   ],
  //   sidebar: {
  //     categories: [
  //       { name: "Thiết Kế Thương Hiệu", count: 3 },
  //       { name: "Marketing Kỹ Thuật Số", count: 2, active: true },
  //       { name: "UI/UX", count: 7 },
  //       { name: "Phát Triển Website", count: 9 },
  //       { name: "Nghiên Cứu Thị Trường", count: 1 },
  //     ],

  //     recentPosts: [
  //       {
  //         title: "Tối Ưu Trải Nghiệm Khách Hàng Qua Thiết Kế Sáng Tạo",
  //         date: "02 Tháng 01, 2025",
  //         image: "/assets/img/news/pp1.webp",
  //         slug: "toi-uu-trai-nghiem-khach-hang",
  //       },
  //       {
  //         title:
  //           "Chiến Lược Marketing Sáng Tạo, Gia Tăng Tương Tác Thương Hiệu",
  //         date: "26 Tháng 12, 2024",
  //         image: "/assets/img/news/pp2.webp",
  //         slug: "chien-luoc-marketing-sang-tao",
  //       },
  //       {
  //         title: "Ứng Dụng Công Nghệ Sáng Tạo Trong Thiết Kế Hiện Đại",
  //         date: "30 Tháng 12, 2024",
  //         image: "/assets/img/news/pp3.webp",
  //         slug: "cong-nghe-sang-tao-thiet-ke-hien-dai",
  //       },
  //     ],
  //     tags: [
  //       "Marketing",
  //       "Thương Hiệu",
  //       "Giải Pháp Số",
  //       "Chiến Lược",
  //       "Sáng Tạo",
  //     ],
  //   },
  // },
  {
    id: 4,
    title: "Chiến Lược Sáng Tạo Nâng Tầm Doanh Nghiệp 2024",
    slug: "chien-luoc-sang-tao-2024",
    author: "Admin",
    date: "22 Tháng 12, 2024",
    category: "Doanh Nghiệp",

    homeImg: "/assets/img/news/chien-luoc-sang-tao-2024/dt3.webp", // chỉ dùng cho trang chủ
    image: "/assets/img/news/chien-luoc-sang-tao-2024/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Design24 áp dụng các chiến lược sáng tạo nhằm nâng cao hiệu quả kinh doanh, từ nhận diện thương hiệu đến trải nghiệm khách hàng.",
      },
      {
        type: "highlight",
        value:
          "Một trong những điểm nổi bật chính là sản xuất TVC quảng cáo. Các video ngắn gọn, súc tích và giàu cảm xúc đã tạo được sự lan tỏa mạnh mẽ trên nền tảng số, củng cố hình ảnh thương hiệu.",
      },
      {
        type: "text",
        value:
          "Các giải pháp sáng tạo được triển khai nhằm tối ưu hóa quá trình truyền thông và quảng bá thương hiệu trên nền tảng số, đảm bảo doanh nghiệp tiếp cận đúng khách hàng mục tiêu.",
      },
      {
        type: "text",
        value:
          "Đội ngũ Design24 kết hợp giữa tư duy chiến lược và thiết kế sáng tạo để đảm bảo doanh nghiệp phát triển bền vững và luôn giữ được sự khác biệt trên thị trường cạnh tranh khốc liệt.",
      },
    ],
    images: [
      "/assets/img/news/chien-luoc-sang-tao-2024/dt2.webp",
      "/assets/img/news/chien-luoc-sang-tao-2024/dt3.webp",
    ],
    contentExtra:
      "Chúng tôi cung cấp giải pháp toàn diện, từ nghiên cứu thị trường, xây dựng chiến lược đến triển khai sáng tạo, giúp doanh nghiệp đạt được mục tiêu kinh doanh và nâng cao giá trị thương hiệu.",
    tags: ["Doanh Nghiệp", "Chiến Lược"],
    comments: [
      {
        name: "Phạm Minh Quân",
        date: "20 Tháng 3, 2024 lúc 14:37",
        message:
          "Chiến lược được xây dựng có chiều sâu, vừa sáng tạo vừa bám sát thị trường. Doanh nghiệp nào áp dụng cũng dễ tạo lợi thế cạnh tranh.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Trần Thị Ngọc Hà",
        date: "21 Tháng 3, 2024 lúc 09:58",
        message:
          "Ấn tượng với cách Design24 triển khai ý tưởng sáng tạo nhưng vẫn giữ được tính thực tiễn. Kết quả rõ ràng và đáng ghi nhận.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Vũ Hoàng Long",
        date: "22 Tháng 3, 2024 lúc 18:22",
        message:
          "Nội dung hay nhưng mình nghĩ có thể bổ sung thêm ví dụ thực tế để thuyết phục hơn. Dù vậy, tổng thể rất chuyên nghiệp.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
        { name: "Doanh Nghiệp", count: 4, active: true },
      ],

      recentPosts: [
        {
          title: "Tối Ưu Trải Nghiệm Khách Hàng Qua Thiết Kế Sáng Tạo",
          date: "02 Tháng 01, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "toi-uu-trai-nghiem-khach-hang",
        },
        {
          title:
            "Chiến Lược Marketing Sáng Tạo, Gia Tăng Tương Tác Thương Hiệu",
          date: "26 Tháng 12, 2024",
          image: "/assets/img/news/pp2.webp",
          slug: "chien-luoc-marketing-sang-tao",
        },
        {
          title: "Ứng Dụng Công Nghệ Sáng Tạo Trong Thiết Kế Hiện Đại",
          date: "30 Tháng 12, 2024",
          image: "/assets/img/news/pp3.webp",
          slug: "cong-nghe-sang-tao-thiet-ke-hien-dai",
        },
      ],
      tags: [
        "Doanh Nghiệp",
        "Chiến Lược",
        "Sáng Tạo",
        "TVC Quảng Cáo",
        "Truyền Thông 2024",
      ],
    },
  },
  {
    id: 5,
    title: "Tạo Trải Nghiệm Người Dùng Xuất Sắc, Gia Tăng Hiệu Quả Kinh Doanh",
    slug: "trai-nghiem-nguoi-dung-xuat-sac",
    author: "Admin",
    date: "24 Tháng 12, 2024",
    category: "UX/UI",

    homeImg: "/assets/img/news/trai-nghiem-nguoi-dung-xuat-sac/dt2.webp", // chỉ dùng cho trang chủ
    image: "/assets/img/news/trai-nghiem-nguoi-dung-xuat-sac/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Design24 tập trung vào việc tạo ra các trải nghiệm người dùng mượt mà, trực quan và hiệu quả, giúp khách hàng đạt mục tiêu kinh doanh.",
      },
      {
        type: "highlight",
        value:
          "Chúng tôi nổi bật trong việc thiết kế giao diện và trải nghiệm, đảm bảo mọi sản phẩm kỹ thuật số đều mang lại cảm giác dễ chịu và thúc đẩy tương tác từ người dùng.",
      },
      {
        type: "text",
        value:
          "Đội ngũ UX/UI kết hợp giữa nghiên cứu người dùng, thiết kế trực quan và thử nghiệm thực tế để tối ưu hóa trải nghiệm trên mọi thiết bị.",
      },
      {
        type: "text",
        value:
          "Mỗi dự án đều được đo lường kết quả và cải tiến liên tục, giúp thương hiệu nổi bật và tăng sự hài lòng của khách hàng.",
      },
    ],
    images: [
      "/assets/img/news/trai-nghiem-nguoi-dung-xuat-sac/dt2.webp",
      "/assets/img/news/trai-nghiem-nguoi-dung-xuat-sac/dt3.webp",
    ],
    contentExtra:
      "Giải pháp UX/UI toàn diện của chúng tôi không chỉ dừng ở thiết kế đẹp, mà còn tập trung vào việc gia tăng tỷ lệ chuyển đổi, tối ưu hành trình khách hàng và nâng cao giá trị thương hiệu. Đây chính là lợi thế cạnh tranh bền vững cho doanh nghiệp trong kỷ nguyên số.",

    tags: ["UX", "Thiết Kế", "Trải Nghiệm Người Dùng"],
    comments: [
      {
        name: "Đỗ Khánh Linh",
        date: "21 Tháng 3, 2024 lúc 09:15",
        message:
          "Thiết kế giao diện mượt mà, dễ thao tác. Mình đặc biệt thích cách tối ưu trải nghiệm trên mobile.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Trần Hoàng Nam",
        date: "22 Tháng 3, 2024 lúc 16:42",
        message:
          "UX/UI đẹp và chuyên nghiệp, nhưng nếu có thêm tính năng cá nhân hóa thì sẽ còn hoàn thiện hơn.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7, active: true },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
        { name: "Doanh Nghiệp", count: 4 },
      ],

      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: [
        "UX",
        "UI",
        "Thiết Kế",
        "Trải Nghiệm Người Dùng",
        "Giao Diện",
        "Mobile App",
        "Website",
      ],
    },
  },
  {
    id: 6,
    title: "Chiến Lược Marketing Sáng Tạo, Gia Tăng Tương Tác Thương Hiệu",
    slug: "chien-luoc-marketing-sang-tao",
    author: "Admin",
    date: "26 Tháng 12, 2024",
    category: "Marketing",

    homeImg: "/assets/img/news/chien-luoc-marketing-sang-tao/dt2.webp",
    image: "/assets/img/news/chien-luoc-marketing-sang-tao/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Design24 luôn tìm kiếm những phương thức marketing sáng tạo, giúp thương hiệu nổi bật và kết nối sâu sắc với khách hàng.",
      },
      {
        type: "highlight",
        value:
          "Chúng tôi nổi bật trong việc thiết kế chiến dịch quảng cáo và marketing kỹ thuật số, từ ý tưởng độc đáo đến triển khai hiệu quả, mang lại sự tương tác cao từ khách hàng.",
      },
      {
        type: "text",
        value:
          "Mỗi chiến dịch được nghiên cứu kỹ lưỡng, đảm bảo phù hợp với mục tiêu thương hiệu và hành vi người dùng.",
      },
      {
        type: "text",
        value:
          "Thông qua phân tích dữ liệu và tối ưu hóa liên tục, các chiến lược marketing của chúng tôi giúp doanh nghiệp tăng trưởng bền vững.",
      },
    ],
    images: [
      "/assets/img/news/chien-luoc-marketing-sang-tao/dt2.webp",
      "/assets/img/news/chien-luoc-marketing-sang-tao/dt3.webp",
    ],
    contentExtra:
      "Các chiến lược marketing sáng tạo tại Design24 không chỉ dừng ở việc thu hút sự chú ý, mà còn tập trung vào tăng trưởng thực tế: nâng cao tỷ lệ chuyển đổi, xây dựng thương hiệu bền vững và mở rộng tệp khách hàng. Đây là sự kết hợp giữa sáng tạo, dữ liệu và công nghệ để tạo nên lợi thế cạnh tranh lâu dài.",

    tags: ["Marketing", "Sáng Tạo", "Thương Hiệu"],
    comments: [
      {
        name: "Phạm Quỳnh Anh",
        date: "23 Tháng 3, 2024 lúc 11:20",
        message:
          "Chiến dịch được triển khai khá thông minh, đặc biệt là phần quảng cáo trên mạng xã hội đã thu hút sự chú ý nhanh chóng.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Ngô Minh Tuấn",
        date: "24 Tháng 3, 2024 lúc 15:05",
        message:
          "Ý tưởng sáng tạo nhưng mình nghĩ phần đo lường hiệu quả nên chi tiết hơn để thuyết phục các doanh nghiệp lớn.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2, active: true },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["Agency", "Giải Thưởng", "Marketing", "Hiện Đại", "Sáng Tạo"],
    },
  },
  {
    id: 7,
    title: "Xu Hướng Thiết Kế Kỹ Thuật Số và Sáng Tạo Trong Tương Lai",
    slug: "xu-huong-thiet-ke-ky-thuat-so",
    author: "Admin",
    date: "28 Tháng 12, 2024",
    category: "Thiết Kế",

    homeImg: "/assets/img/news/xu-huong-thiet-ke-ky-thuat-so/dt3.webp", // chỉ dùng cho trang chủ
    image: "/assets/img/news/xu-huong-thiet-ke-ky-thuat-so/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Design24 luôn theo dõi các xu hướng thiết kế mới nhất, từ digital đến creative, để mang đến giải pháp tiên tiến cho khách hàng.",
      },
      {
        type: "highlight",
        value:
          "Chúng tôi nổi bật trong việc ứng dụng AI, thiết kế giao diện số và chiến lược sáng tạo trực tuyến. Mỗi dự án không chỉ tập trung vào thẩm mỹ mà còn hướng đến hiệu quả kinh doanh và trải nghiệm khách hàng.",
      },
      {
        type: "text",
        value:
          "Sự kết hợp giữa sáng tạo và công nghệ giúp các thương hiệu của khách hàng nổi bật trong môi trường kỹ thuật số cạnh tranh.",
      },
      {
        type: "text",
        value:
          "Design24 luôn tiên phong ứng dụng các công cụ, phương pháp và xu hướng mới để đảm bảo sản phẩm luôn hiện đại và hiệu quả.",
      },
    ],
    images: [
      "/assets/img/news/xu-huong-thiet-ke-ky-thuat-so/dt2.webp",
      "/assets/img/news/xu-huong-thiet-ke-ky-thuat-so/dt3.webp",
    ],
    contentExtra:
      "Chúng tôi cung cấp các giải pháp thiết kế toàn diện, từ nhận diện thương hiệu, thiết kế trải nghiệm người dùng đến chiến lược sáng tạo kỹ thuật số, giúp doanh nghiệp dẫn đầu xu hướng và tối ưu hóa hiệu quả marketing.",
    tags: ["Digital", "Xu Hướng", "Thiết Kế"],
    comments: [
      {
        name: "Đặng Thu Hà",
        date: "25 Tháng 3, 2024 lúc 09:50",
        message:
          "Điểm mình thích nhất là cách Design24 đưa công nghệ mới vào thiết kế, vừa hiện đại vừa thực tế cho doanh nghiệp.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Nguyễn Minh Khôi",
        date: "26 Tháng 3, 2024 lúc 13:28",
        message:
          "Xu hướng rất hay, nhưng mình nghĩ nếu có thêm ví dụ thực tế ở Việt Nam thì sẽ dễ hình dung hơn.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
        { name: "Thiết Kế", count: 4, active: true },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["Agency", "Giải Thưởng", "Marketing", "Hiện Đại", "Sáng Tạo"],
    },
  },
  {
    id: 8,
    title: "Ứng Dụng Công Nghệ Sáng Tạo Trong Thiết Kế Hiện Đại",
    slug: "cong-nghe-sang-tao-thiet-ke-hien-dai",
    author: "Admin",
    date: "30 Tháng 12, 2024",
    category: "Thiết Kế",

    homeImg: "/assets/img/news/cong-nghe-sang-tao-thiet-ke-hien-dai/dt2.webp", // chỉ dùng cho trang chủ
    image: "/assets/img/news/cong-nghe-sang-tao-thiet-ke-hien-dai/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Trong kỷ nguyên số, việc ứng dụng công nghệ sáng tạo trong thiết kế giúp thương hiệu nổi bật và kết nối hiệu quả với khách hàng.",
      },
      {
        type: "highlight",
        value:
          "Design24 tận dụng các công cụ kỹ thuật số hiện đại như thiết kế 3D, motion graphics và UI/UX. Những công nghệ này không chỉ tạo trải nghiệm trực quan mà còn giúp doanh nghiệp tăng mức độ nhận diện và xây dựng hình ảnh thương hiệu khác biệt.",
      },
      {
        type: "text",
        value:
          "Sự kết hợp giữa sáng tạo và công nghệ không chỉ tăng giá trị thương hiệu mà còn thúc đẩy hiệu quả kinh doanh lâu dài.",
      },
      {
        type: "text",
        value:
          "Mỗi dự án đều được nghiên cứu kỹ lưỡng, tối ưu trải nghiệm người dùng và đảm bảo sự khác biệt trên thị trường cạnh tranh.",
      },
    ],
    images: [
      "/assets/img/news/cong-nghe-sang-tao-thiet-ke-hien-dai/dt2.webp",
      "/assets/img/news/cong-nghe-sang-tao-thiet-ke-hien-dai/dt3.webp",
    ],
    contentExtra:
      "Chúng tôi cung cấp giải pháp toàn diện từ thiết kế thương hiệu, trải nghiệm số đến marketing sáng tạo, giúp doanh nghiệp nổi bật, thu hút khách hàng và dẫn đầu xu hướng.",
    tags: ["Công Nghệ", "Sáng Tạo", "Thiết Kế"],
    comments: [
      {
        name: "Hoàng Đức Anh",
        date: "29 Tháng 12, 2024 lúc 09:40",
        message:
          "Mình rất ấn tượng với cách Design24 ứng dụng motion graphics, thiết kế sống động và truyền tải thông điệp rõ ràng.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Ngô Thùy Linh",
        date: "29 Tháng 12, 2024 lúc 15:10",
        message:
          "Xu hướng công nghệ rất hay, nhưng nếu có thêm số liệu minh chứng hiệu quả (ví dụ tăng tương tác bao nhiêu %) thì sẽ thuyết phục hơn.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Thiết Kế", count: 5, active: true },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["Agency", "Giải Thưởng", "Marketing", "Hiện Đại", "Sáng Tạo"],
    },
  },
  {
    id: 9,
    title: "Tối Ưu Trải Nghiệm Khách Hàng Qua Thiết Kế Sáng Tạo",
    slug: "toi-uu-trai-nghiem-khach-hang",
    author: "Admin",
    date: "2 Tháng 1, 2025",
    category: "UX/UI",

    homeImg: "/assets/img/news/toi-uu-trai-nghiem-khach-hang/dt3.webp", // chỉ dùng cho trang chủ
    image: "/assets/img/news/toi-uu-trai-nghiem-khach-hang/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Trải nghiệm khách hàng là yếu tố then chốt quyết định sự thành công của thương hiệu trong thị trường cạnh tranh hiện nay.",
      },
      {
        type: "highlight",
        value:
          "Design24 tập trung vào việc nghiên cứu hành vi người dùng, tối ưu giao diện và tương tác số. Nhờ đó, thương hiệu không chỉ gia tăng sự hài lòng mà còn cải thiện tỷ lệ giữ chân và khuyến khích khách hàng quay lại.",
      },
      {
        type: "text",
        value:
          "Một trải nghiệm tốt không chỉ giúp khách hàng nhớ đến thương hiệu mà còn thúc đẩy họ chia sẻ và quảng bá tự nhiên.",
      },
      {
        type: "text",
        value:
          "Mỗi dự án UX/UI đều được đội ngũ chuyên môn của chúng tôi triển khai bài bản, từ nghiên cứu, thiết kế đến kiểm thử thực tế.",
      },
    ],
    images: [
      "/assets/img/news/toi-uu-trai-nghiem-khach-hang/dt2.webp",
      "/assets/img/news/toi-uu-trai-nghiem-khach-hang/dt3.webp",
    ],
    contentExtra:
      "Chúng tôi cam kết mang đến những giải pháp thiết kế trải nghiệm người dùng độc đáo, giúp doanh nghiệp xây dựng hình ảnh thương hiệu mạnh mẽ và hiệu quả kinh doanh bền vững.",
    tags: ["UX", "UI", "Trải Nghiệm Khách Hàng"],
    comments: [
      {
        name: "Đặng Thu Trang",
        date: "2 Tháng 1, 2025 lúc 09:50",
        message:
          "Điểm mình thích là cách Design24 nghiên cứu hành vi người dùng kỹ lưỡng, giao diện mượt và dễ sử dụng hơn hẳn.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Vũ Minh Khôi",
        date: "2 Tháng 1, 2025 lúc 10:30",
        message:
          "Thiết kế đẹp và tối ưu, nhưng nếu có thêm ví dụ số liệu cụ thể (tăng bao nhiêu % khách quay lại) thì sẽ thuyết phục hơn nữa.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3 },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7, active: true },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: ["UX", "UI", "Khách Hàng", "Thiết Kế", "Trải Nghiệm"],
    },
  },
  {
    id: 10,
    title: "Sáng Tạo Thương Hiệu Đột Phá Trong Kỷ Nguyên Số",
    slug: "sang-tao-thuong-hieu-ky-nguyen-so",
    author: "Admin",
    date: "5 Tháng 1, 2025",
    category: "Branding",

    homeImg: "/assets/img/news/sang-tao-thuong-hieu-ky-nguyen-so/dt2.webp",
    image: "/assets/img/news/sang-tao-thuong-hieu-ky-nguyen-so/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Trong môi trường cạnh tranh ngày nay, thương hiệu không chỉ là logo hay slogan mà còn là trải nghiệm tổng thể mà khách hàng nhận được.",
      },
      {
        type: "highlight",
        value:
          "Design24 cung cấp giải pháp sáng tạo toàn diện: từ nhận diện thương hiệu, chiến lược marketing đến thiết kế sản phẩm số. Nhờ vậy, doanh nghiệp không chỉ nổi bật trên thị trường mà còn tạo dựng được lòng tin và kết nối bền vững với khách hàng.",
      },
      {
        type: "text",
        value:
          "Việc xây dựng thương hiệu đột phá đòi hỏi hiểu rõ khách hàng mục tiêu, xu hướng thị trường và khả năng sáng tạo không giới hạn.",
      },
      {
        type: "text",
        value:
          "Mỗi dự án được thực hiện với mục tiêu tối đa hóa giá trị thương hiệu và tạo ấn tượng lâu dài trong tâm trí khách hàng.",
      },
    ],
    images: [
      "/assets/img/news/sang-tao-thuong-hieu-ky-nguyen-so/dt2.webp",
      "/assets/img/news/sang-tao-thuong-hieu-ky-nguyen-so/dt3.webp",
    ],
    contentExtra:
      "Chúng tôi cam kết đồng hành cùng doanh nghiệp trong hành trình xây dựng thương hiệu mạnh mẽ, sáng tạo và khác biệt, từ ý tưởng đến hiện thực hóa.",
    tags: ["Branding", "Sáng Tạo", "Marketing"],
    comments: [
      {
        name: "Hoàng Bảo Ngọc",
        date: "5 Tháng 1, 2025 lúc 11:20",
        message:
          "Ấn tượng nhất là cách Design24 xây dựng thương hiệu đồng bộ cả online lẫn offline, giúp doanh nghiệp dễ ghi dấu trong tâm trí khách hàng.",
        rating: 5,
        avatar: "/assets/img/news/c1.webp",
      },
      {
        name: "Ngô Đức Thịnh",
        date: "5 Tháng 1, 2025 lúc 12:10",
        message:
          "Ý tưởng sáng tạo rất tốt, nhưng mình nghĩ nếu chia sẻ thêm case study thực tế sẽ giúp thuyết phục hơn nữa.",
        rating: 4,
        avatar: "/assets/img/news/c2.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3, active: true },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],

      recentPosts: [
        {
          title:
            "Học viện Design24 ra mắt bộ công cụ AI 'Made in Vietnam', mở ra trải nghiệm thú vị cho mọi đối tượng",
          date: "16 Tháng 9, 2025",
          image: "/assets/img/news/ai-chat-studio/dt4.png",
          slug: "design24-ra-mat-bo-cong-cu-ai",
        },
        {
          title:
            "5 Công Cụ Thiết Kế Online Miễn Phí Dành Cho Người Mới Bắt Đầu",
          date: "07 Tháng 9, 2025",
          image: "/assets/img/news/5-tools-design-online/dt3.webp",
          slug: "5-cong-cu-thiet-ke-online-mien-phi",
        },
        {
          title: "Khóa Học 10 Kỹ Năng AI Tại Học Viện Design24",
          date: "27 Tháng 8, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "khoa-hoc-10-ky-nang-ai-design24",
        },
      ],
      tags: [
        "Branding",
        "Nhận Diện",
        "Chiến Lược",
        "Marketing",
        "Kỷ Nguyên Số",
      ],
    },
  },
  {
    id: 11,
    title: "Nghệ Thuật Sáng Tạo Chiến Lược",
    slug: "nghe-thuat-sang-tao-chien-luoc",
    author: "Admin",
    date: "18 Tháng 12, 2024",
    category: "Thiết Kế",
    homeImg: "/assets/img/news/nghe-thuat-sang-tao-chien-luoc/dt3.webp",
    image: "/assets/img/news/nghe-thuat-sang-tao-chien-luoc/dt1.webp",
    content: [
      {
        type: "text",
        value:
          "Tại Design24, chúng tôi luôn tìm kiếm giải pháp sáng tạo kết hợp chiến lược thương hiệu, giúp mỗi dự án không chỉ đẹp mắt mà còn hiệu quả thực tế.",
      },
      {
        type: "highlight",
        value:
          "Design24 nổi bật với khả năng kết hợp giữa thiết kế sáng tạo và chiến lược thương hiệu. Chúng tôi không chỉ tạo ra sản phẩm đẹp mắt mà còn đảm bảo tính ứng dụng, gia tăng doanh số và trải nghiệm khách hàng.",
      },
      {
        type: "text",
        value:
          "Mỗi sản phẩm được chăm chút từ bố cục, màu sắc đến hình ảnh minh họa, đảm bảo sự đồng bộ và cuốn hút người dùng.",
      },
      {
        type: "text",
        value:
          "Đội ngũ Design24 kết hợp giữa sáng tạo và phân tích dữ liệu để mang lại giải pháp tối ưu cho thương hiệu.",
      },
    ],
    images: [
      "/assets/img/news/nghe-thuat-sang-tao-chien-luoc/dt2.webp",
      "/assets/img/news/nghe-thuat-sang-tao-chien-luoc/dt3.webp",
    ],
    contentExtra:
      "Design24 cam kết đem đến các giải pháp thiết kế toàn diện, từ nghiên cứu, phát triển ý tưởng đến triển khai thực tế, giúp thương hiệu nổi bật và ghi dấu ấn lâu dài.",
    tags: ["Thiết Kế", "Sáng Tạo", "Thương Hiệu"],
    comments: [
      {
        name: "Lê Thiên Phúc",
        date: "20 Tháng 3, 2024 lúc 14:37",
        message:
          "Dự án vượt ngoài mong đợi. Thiết kế tinh tế, trải nghiệm người dùng mượt mà và đầy tính chiến lược.",
        rating: 5,
        avatar: "/assets/img/news/c2.webp",
      },
      {
        name: "Nguyễn Hoàng Yến",
        date: "20 Tháng 3, 2024 lúc 15:12",
        message:
          "Thiết kế rất sáng tạo và hợp xu hướng. Mình nghĩ nếu bổ sung thêm phần nghiên cứu thị trường cụ thể thì sẽ còn thuyết phục hơn.",
        rating: 4,
        avatar: "/assets/img/news/c1.webp",
      },
    ],
    sidebar: {
      categories: [
        { name: "Thiết Kế Thương Hiệu", count: 3, active: true },
        { name: "Marketing Kỹ Thuật Số", count: 2 },
        { name: "UI/UX", count: 7 },
        { name: "Phát Triển Website", count: 9 },
        { name: "Nghiên Cứu Thị Trường", count: 1 },
      ],
      recentPosts: [
        {
          title: "Tối Ưu Trải Nghiệm Khách Hàng Qua Thiết Kế Sáng Tạo",
          date: "02 Tháng 01, 2025",
          image: "/assets/img/news/pp1.webp",
          slug: "toi-uu-trai-nghiem-khach-hang",
        },
        {
          title:
            "Chiến Lược Marketing Sáng Tạo, Gia Tăng Tương Tác Thương Hiệu",
          date: "26 Tháng 12, 2024",
          image: "/assets/img/news/pp2.webp",
          slug: "chien-luoc-marketing-sang-tao",
        },
        {
          title: "Ứng Dụng Công Nghệ Sáng Tạo Trong Thiết Kế Hiện Đại",
          date: "30 Tháng 12, 2024",
          image: "/assets/img/news/pp3.webp",
          slug: "cong-nghe-sang-tao-thiet-ke-hien-dai",
        },
      ],
      tags: ["Thiết Kế", "Chiến Lược", "Sáng Tạo", "Thương Hiệu", "Bao Bì"],
    },
  },
];
